module.exports = __webpack_public_path__ + "static/23invgde-819b2030d612675f0b8228155699b2e1.gif";